import React from 'react';
import {useState} from "react";
import {AppWrap} from "../../wrapper";
import {images} from "../../constants";
import {client} from "../../client";
import './footer.scss'

const Footer = () => {

    const [formData, setFormData] = useState({name:'', email:'', message:''});
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false)

    const {name, email, message} = formData;

    const handleChangeInput = (e) => {
        const {name, value} = e.target;

        setFormData({...formData, [name]: value})
    }

    const handleSubmit = () => {
        setLoading(true);

        const contact = {
            _type: 'contact',
            name: name,
            email: email,
            message: message
        }

        client.create(contact)
            .then(() => {
                setLoading(false);
                setFormSubmitted(true);
            })
    }

        return (
            <div className="app__contact">
                <h2 className="head-text">Contact Us</h2>

                <div className="app__footer-cards">
                    <div className="app__footer-card">
                        <img src={images.email} alt="email"/>
                        <a href="mailto:surangaishara8@gmail.com" className="p-text">sur...8@gmail.com</a>
                    </div>

                    <div className="app__footer-card">
                        <img src={images.mobile} alt="mobile"/>
                        <a href="tel: +94 (713) 235 898" className="p-text">+94 (713) 235 898</a>
                    </div>
                </div>

                {!formSubmitted ?
                    <div className="app__footer-form app__flex">
                        <div className="aoo__flex">
                            <input className="p-text" name="name" type="text" placeholder="Your Name" value={name}
                                   onChange={handleChangeInput}/>
                        </div>

                        <div className="aoo__flex">
                            <input className="p-text" name="email" type="email" placeholder="Your Email" value={email}
                                   onChange={handleChangeInput}/>
                        </div>

                        <div>
                            <textarea name="message" className="p-text" placeholder="Your Message" value={message}
                                      onChange={handleChangeInput}></textarea>
                        </div>

                        <button className="p-text" type='button'
                                onClick={handleSubmit}>{loading ? "Sending" : 'Send Message'}</button>
                    </div>
                    :
                    <div>
                        <h3 className="head-text">Thank you for getting touch</h3>
                    </div>
                }
            </div>

        );

}

export default AppWrap(Footer, 'contact');